import React from 'react';
import { Briefcase } from 'lucide-react';
import JobCard from '../JobCard/JobCard';
import Pagination from '../Pagination/Pagination';
import SecondaryLoader from '../SecondaryLoader/SecondaryLoader';

const JobsList = ({
  jobs = [],
  savedJobs = {},
  loading = false,
  loadingMore = false,
  error = null,
  currentPage = 0,
  pagination = { totalResults: 0, hasMore: false },
  showPagination = true,
  showRemoveButton = false,
  emptyStateMessage = "No jobs found",
  onSaveJob,
  onRemoveJob,
  onPreviousPage,
  onNextPage,
  onRetry
}) => {
  return (
    <>
      {/* Loading State */}
      {loading && (
        <SecondaryLoader message="Loading jobs..." />
      )}

      {/* Error State */}
      {error && (
        <div className="bg-red-50 border border-red-200 rounded-lg p-6 mb-8">
          <div className="flex items-center">
            <div className="text-red-600 mr-3">
              <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
              </svg>
            </div>
            <div>
              <h3 className="text-red-800 font-semibold">Error Loading Jobs</h3>
              <p className="text-red-600 mt-1">{error}</p>
              {onRetry && (
                <button
                  onClick={onRetry}
                  className="mt-3 bg-red-600 text-white px-4 py-2 rounded-lg text-sm hover:bg-red-700 transition-colors"
                >
                  Try Again
                </button>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Job Cards */}
      {!loading && !error && (
        <>
          <div className="space-y-6 mb-8">
            {jobs.length > 0 ? (
              jobs.map((job) => (
                <JobCard
                  key={job.id || job.jobId}
                  job={job}
                  isSaved={savedJobs[job.id] || false}
                  showRemoveButton={showRemoveButton}
                  onSaveJob={onSaveJob}
                  onRemoveJob={onRemoveJob}
                />
              ))
            ) : (
              <div className="text-center py-12">
                <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Briefcase className="w-8 h-8 text-gray-400" />
                </div>
                <div className="text-gray-500 text-lg mb-2">{emptyStateMessage}</div>
                <div className="text-gray-400 text-sm">Start exploring jobs and save the ones you're interested in</div>
              </div>
            )}
            
            {/* Loading More Indicator */}
            {loadingMore && (
              <div className="flex justify-center py-4">
                <SecondaryLoader message="Loading more jobs..." />
              </div>
            )}
          </div>

          {/* Pagination - Only show if jobs exist and showPagination is true */}
          {jobs.length > 0 && showPagination && (
            <Pagination
              currentPage={currentPage}
              hasMore={pagination.hasMore}
              onPrevious={onPreviousPage}
              onNext={onNextPage}
              loading={loadingMore}
            />
          )}
        </>
      )}
    </>
  );
};

export default JobsList;
